export const COGNITO_CONFIG = {
  REGION: process.env.NEXT_PUBLIC_AWS_REGION,
  USER_POOL_ID: process.env.NEXT_PUBLIC_COGNITO_USER_POOL_ID,
  CLIENT_ID: process.env.NEXT_PUBLIC_COGNITO_CLIENT_ID,
  IDENTITY_POOL_ID: process.env.NEXT_PUBLIC_COGNITO_IDENTITY_POOL_ID,
  GOOGLE_CLIENT_ID: process.env.NEXT_PUBLIC_GOOGLE_CLIENT_ID,
} as const;

// Validate configuration
if (
  !COGNITO_CONFIG.REGION ||
  !COGNITO_CONFIG.USER_POOL_ID ||
  !COGNITO_CONFIG.CLIENT_ID
) {
  console.error('Missing required AWS Cognito configuration:', COGNITO_CONFIG);
  throw new Error(
    'Missing required AWS Cognito configuration. Please check your environment variables.'
  );
}

export type CognitoConfig = typeof COGNITO_CONFIG;
